import React from 'react';
import type { ViewProps } from 'react-native';

import { BodyText } from '@garnish/core';

// ────────────────────────────────────────────────────────────────────────────────

export const LineItemDescription = (props: LineItemDescriptionProps) => {
  const { children, productSlug, selectable } = props;

  return (
    <BodyText
      selectable={selectable}
      sizeMatch={['14']}
      testID={`sg-line-item-card-description-${productSlug}`}
    >
      {children}
    </BodyText>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

type LineItemDescriptionProps = Readonly<{
  productSlug: string;
  selectable?: boolean;
  children: ViewProps['children'];
}>;
